export default __webpack_public_path__ + "static/media/syndi-header.84a74a4a.png";